import React, { useState, useEffect } from 'react';
import './PoweredBy.css';
import { API_BASE_URL } from '../utils/apiBase';

const PoweredBy = () => {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchConfig();
  }, []);

  const fetchConfig = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/event-config`);
      const data = await response.json();
      setConfig(data);
    } catch (error) {
      console.error('Error fetching config:', error);
      // Use default config if API fails
      setConfig({
        poweredBy: {
          enabled: true,
          name: 'DevOpsClinics',
          email: 'info@devopclinics.com',
          website: 'https://devopclinics.com'
        }
      });
    } finally {
      setLoading(false);
    }
  };

  if (loading || !config || !config.poweredBy || config.poweredBy.enabled === false) {
    return null;
  }

  const { name, email, website } = config.poweredBy;

  return (
    <footer className="powered-by-footer">
      <div className="powered-by-content">
        <span className="powered-by-text">
          ⚡ Powered by{' '}
          {website ? (
            <a 
              href={website} 
              target="_blank" 
              rel="noopener noreferrer"
              className="powered-by-link"
            >
              {name}
            </a>
          ) : (
            <strong>{name}</strong>
          )}
        </span>
        {email && (
          <span className="powered-by-contact">
            📧{' '}
            <a 
              href={`mailto:${email}`}
              className="powered-by-email"
            >
              {email}
            </a>
          </span>
        )}
      </div>
    </footer>
  );
};

export default PoweredBy;
